import { render, staticRenderFns } from "./EditarVendedorDialog.vue?vue&type=template&id=23d1d3b9"
import script from "./EditarVendedorDialog.vue?vue&type=script&lang=js"
export * from "./EditarVendedorDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports